import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/articles';

export default function Hero() {
  const heroArticle = featuredArticles[0];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src={heroArticle.imageUrl}
        alt={heroArticle.title}
        className="absolute inset-0 w-full h-full object-cover object-top"
        title={`${heroArticle.title} - The Vertex`}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col justify-end pb-10 md:pb-16 px-4 md:px-6">
        <div className="max-w-7xl mx-auto w-full">
          <div className="max-w-3xl">
            <Link
              to={`/category/${heroArticle.category}`}
              className="inline-block px-3 py-1 rounded-full bg-accent-500/20 backdrop-blur-sm text-background-50 text-xs font-label font-medium tracking-wide uppercase mb-4 md:mb-5 cursor-pointer hover:bg-accent-500/30 transition-colors"
            >
              {heroArticle.category}
            </Link>
            <Link to={`/article/${heroArticle.slug}`} className="block group cursor-pointer">
              <h1 className="text-2xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-3 md:mb-4 group-hover:text-background-50/90 transition-colors">
                {heroArticle.title}
              </h1>
              <p className="text-sm md:text-base text-background-50/70 leading-relaxed max-w-2xl mb-5 md:mb-6">
                {heroArticle.excerpt}
              </p>
            </Link>
            <div className="flex items-center gap-4 text-background-50/60 text-xs md:text-sm">
              <span className="font-medium text-background-50/90">{heroArticle.author}</span>
              <span className="w-1 h-1 rounded-full bg-background-50/30"></span>
              <span>{heroArticle.date}</span>
              <span className="w-1 h-1 rounded-full bg-background-50/30"></span>
              <span>{heroArticle.readTime}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 md:bottom-10 right-4 md:right-6 z-10">
        <div className="flex items-center gap-2 text-background-50/40 text-[10px] md:text-xs font-label tracking-widest uppercase">
          <span>The Vertex</span>
          <span className="w-8 h-px bg-background-50/20"></span>
          <span>Editorial</span>
        </div>
      </div>
    </section>
  );
}